<template>
  <div class="editMigracoes">
    <el-form
      v-loading="loadingPage"
      :model="ruleForm"
      ref="ruleForm"
      @submit.prevent
      v-on:submit.prevent
    >
      <HeaderPage />
      <el-card>
        <el-row :gutter="20">
          <el-col :lg="8" :sm="6" :md="4" :xs="8">
            <el-form-item prop="marketplace_id" label="Marketplace">
              <el-input
                v-model="ruleForm.marketplace_name_store_external"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :lg="4" :sm="6" :md="4" :xs="8">
            <el-form-item prop="status" label="Status"> </el-form-item>
            <tagStatus :status="ruleForm.status" class="mt--15" />
          </el-col>

          <el-col :lg="8" :sm="6" :md="4" :xs="8">
            <el-button
              @click.prevent="submitForm('ruleForm')"
              style="text-align: center"
              class="mt-20"
              type="primary"
              :disabled="ruleForm.status == 'succeeded'"
            >
              <span>Continuar Migração</span>
            </el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-table :data="listLogsData" border style="width: 100%">
            <el-table-column prop="id" label="ID" width="100" />
            <el-table-column prop="migration_step_status.name" label="Etapa Migração" />
            <el-table-column prop="message" label="Erro" />
            <el-table-column prop="value" label="Dado errado" />
            <el-table-column label="Ação" width="150">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  plain
                  @click="
                    () => {
                      reprocess(scope.row.id);
                    }
                  "
                >
                  Reprocessar
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-col :lg="12"> </el-col>
        </el-row>
      </el-card>
    </el-form>
  </div>
</template>

<script>
import HeaderPage from "@/app/components/HeaderPage";
import { getErrorFilds, makeErrorFilds } from "@/app/plugins/utils";

import {
  postContinueMigracoes,
  getMigration,
  postReprocessarLogMigracoes,
  getLogsMigracao,
} from "@/app/domains/Config/services";
import { mapGetters } from "vuex";
import tagStatus from "@/app/components/Table/TagStatus";

export default {
  name: "editMigracoes",
  components: {
    HeaderPage,
    tagStatus,
  },
  data() {
    return {
      listLogsData: [],
      ruleForm: {
        marketplace_id: "",
        status: "",
      },
      loadingPage: false,
      isEditMKT: true,
      listData: {},
    };
  },
  methods: {
    async reprocess(id) {
      try {
        this.loadingPage = true;
        let res = await postReprocessarLogMigracoes(id);
        if(res.error != undefined && res.error == true){
          this.$message({
          showClose: true,
          message: res.data,
          type: "error",
        });
        }else{
          this.$message({
          showClose: true,
          message: "Log processado com sucesso",
          type: "success",
        });
        }
     
      //  location.reload()
      } catch (e) {
        this.error = getErrorFilds(e);
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: "error",
        });
      } finally {
        this.loadingPage = false;
      }
    },
    submitForm(ruleForm) {
      this.$refs[ruleForm].validate(async (valid, i) => {
        if (valid) {
          try {
            this.loadingPage = true;
            if (this.ruleForm.id) {
              await postContinueMigracoes(this.ruleForm.id);
              this.$message({
                showClose: true,
                message: "MarketPlace Migrado com sucesso",
                type: "success",
              });
              await this.$router.push({ name: "config.ListMigracoes.index" });
            }
          } catch (e) {
            this.error = getErrorFilds(e);
            this.$message({
              showClose: true,
              message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
              type: "error",
            });
          } finally {
            this.loadingPage = false;
          }
        }
      });
    },
  },
  async mounted() {
    this.loadingPage = true;
    try {
      if (this.$route.params.id) {
        let response = await getMigration(this.$route.params.id);
        this.ruleForm = response.data;
        let responseLogs = await getLogsMigracao(
          "?migration_step_id=" + this.$route.params.id
        );
        this.listLogsData = responseLogs.data.data;
        
      }
    } catch (e) {
      this.$message.error(e.message);
    } finally {
      this.loadingPage = false;
    }
  },

  computed: {
    isEdit: function () {
      return !!this.ruleForm.id;
    },
    ...mapGetters("Auth", ["currentUser"]),
  },
};
</script>
